import React from "react";
import { Button, Table } from "@/Components/ui";;

import { useTable } from 'react-table'
import { BsSortDownAlt, BsSortUp } from 'react-icons/bs'

const splitKeyProp = (props) => {
    const { key, ...rest } = props;
    return { key, props: rest };
}

const CustomTable = ({ data, columns, onClickSort }) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data })

    const _data = data.map((el, i) => {
        return -1
    })
    const [sortState, setSort] = React.useState([..._data])

    return (
        <div className="w-full overflow-x-auto">
            <Table {...getTableProps()} className="w-full mb-0 border-y border-slate-200">
                <thead className="bg-slate-50 border-b border-slate-200 text-slate-500">
                    {headerGroups.map((headerGroup) => {
                        const headerGroupProps = splitKeyProp(headerGroup.getHeaderGroupProps());
                        return (
                            <tr {...headerGroupProps.props} key={headerGroupProps.key || headerGroup.id}>
                                {headerGroup.headers.map((column, col_i) => {
                                    const headerProps = splitKeyProp(column.getHeaderProps());
                                    return (
                                        <th
                                            {...headerProps.props}
                                            key={headerProps.key || column.id}
                                            className="h-12 px-4 text-left align-middle font-medium"
                                        >
                                            <div className="flex items-center">
                                                {column.render('Header')}
                                                {(col_i > 0 && onClickSort) ?
                                                    <span
                                                        className="ml-2 cursor-pointer inline-flex"
                                                        style={{ color: sortState[col_i] === -1 ? "#cbd5e1" : "#475569" }}
                                                        onClick={() => {
                                                            onClickSort(column.id, sortState[col_i])
                                                            // for (let i = 0; i < sortState.length; i++) {
                                                            //     if (col_i !== i) sortState[i] = -1
                                                            // }
                                                            sortState[col_i] = !sortState[col_i]
                                                            setSort({ ...sortState })
                                                        }}>{sortState[col_i] ? <BsSortDownAlt /> : <BsSortUp />}</span> : ""}
                                            </div>
                                        </th>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </thead>
                <tbody {...getTableBodyProps()} className="divide-y divide-slate-100">
                    {rows.map((row, i) => {
                        prepareRow(row)
                        const rowProps = splitKeyProp(row.getRowProps());
                        return (
                            <tr {...rowProps.props} key={rowProps.key || i} className="hover:bg-slate-50/80 transition-colors">
                                {row.cells.map((cell, idx) => {
                                    const cellProps = splitKeyProp(cell.getCellProps());
                                    return (
                                        <td
                                            {...cellProps.props}
                                            key={cellProps.key || idx}
                                            className="p-4 align-middle text-slate-700"
                                        >
                                            {cell.render('Cell')}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>
    );
}

export default CustomTable;
